import React from 'react';
import Router from 'next/router';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Box, Flex } from '@components/layout/Grid';
import ThumbnailWithRatio, {
  BackgroundImage,
} from '@components/ThumbnailWithRatio';
import { NextDayTitle } from '@components/texts';
import PlayCicle from '@assets/PlayCircle.js';
import { ProgramCategory } from '@gql/generated';

const Wrapper = styled.div`
  display: flex;
`;

const ThumbWrapper = styled(Box)<{
  appearance?: ProgramCategory;
  progress: number;
}>`
  position: relative;
  ${({ isHighlighted, appearance, theme }) => {
    return '';
    // if (isHighlighted) {
    //   if (appearance === ProgramCategory['Courses']) {
    //     return `border: 2px solid ${theme.colors.primary.green};`;
    //   } else {
    //     return `border: 2px solid ${theme.colors.secondary['gray-5']};`;
    //   }
    // }
  }}
  border-radius: ${({ isHighlighted }) => (isHighlighted ? '6px' : '4px')};
  overflow: hidden;

  :after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: ${({ progress }) => progress}%;
    background-color: #129edc;
  }
`;

const Thumbnail = styled(ThumbnailWithRatio)<{
  appearance?: ProgramCategory;
}>`
  ${BackgroundImage} {
    ${({ isLocked, appearance, theme }) =>
      isLocked
        ? `
          :before {
            background-color: ${
              appearance === ProgramCategory['Challenges']
                ? theme.colors.primary.green
                : theme.colors.primary.stone
            };
          }
        `
        : ''}
  }
`;

const VideoTag = styled.span`
  display: inline-flex;
  align-items: center;
  color: #242424;
  font-size: 12px;
  margin-right: 5px;

  & + & {
    margin-left: 5px;
  }

  svg {
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }
`;

type Props = {
  lang: string;
  videoId: string;
  onClick?(): void;
  redirectTo?: {
    programId: string;
    phaseId: string;
    stepId: string;
  };
  status?: string;
  isHighlighted: boolean;
  videoThumbnail: string;
  videoTitle: string;
  videoDuration: number;
  videoCursorAt: number;
  tags: string[];
  programCategory?: ProgramCategory;
};

const VideoBox = (props: Props) => {
  const progress = props.videoCursorAt
    ? Math.floor(((props.videoCursorAt / 60) * 100) / props.videoDuration)
    : 0;

  return (
    <Wrapper
      // DO NOT REMOVE THE CLASS videoBox, ITS USED TO DRAW THE PROGRESS INDICATOR
      className="videoBox"
      onClick={() => {
        if (typeof props.onClick === 'function') {
          props.onClick();
        } else if (props.status !== 'locked') {
          Router.push(
            `/${props.lang}/${props.programCategory}/${props.redirectTo.programId}/${props.redirectTo.phaseId}/${props.redirectTo.stepId}/${props.videoId}`,
            null,
            { scroll: false }
          );
        }
      }}
      style={{ cursor: 'pointer' }}
      // DO NOT REMOVE THE DATA ATTRIBUTES, THEY ARE USED TO DRAW THE PROGRESS INDICATOR
      data-video-finished={props?.['meta-data']?.finished === true}
      data-video-bonus={props?.['meta-data']?.bonus}
      data-video-last={props?.['meta-data']?.last}
      data-testid="VideoBox"
    >
      <ThumbWrapper
        flex="0 0 108px"
        mr="10px"
        isHighlighted={props.isHighlighted}
        appearance={props.programCategory}
        progress={progress}
      >
        <Thumbnail
          path={props.videoThumbnail}
          appearance={props.programCategory}
          isLocked={props.status === 'locked'}
        />
      </ThumbWrapper>
      <Flex flexDirection="column" justifyContent="center">
        <NextDayTitle
          isCurrent={props.isHighlighted}
          title={props.videoTitle}
          data-testid="VideoBox--Title"
        >
          {props.videoTitle}
        </NextDayTitle>
        <Flex alignItems="center">
          <VideoTag>
            <PlayCicle /> {props.videoDuration} min
          </VideoTag>
          {(props.tags || []).map(tag => {
            if (typeof tag === 'string') {
              return (
                <React.Fragment key={tag}>
                  {' - '}
                  <VideoTag key={tag}>
                    <Trans id={tag} />
                  </VideoTag>
                </React.Fragment>
              );
            }

            return tag;
          })}
        </Flex>
      </Flex>
    </Wrapper>
  );
};

export default VideoBox;
